module.exports = __webpack_public_path__ + "media/images/new-ui-images/return-transfer-fd87dd9ce84021926e55c57314c5bb89.svg";